export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14961.5996e240.jpg";